const parseFetchResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;

      return Promise.reject(error);
    }

    return data;
  });
};
//import { trackSearch, trackSearchResultClicks } from "@everberg/lib/data-layer";


(function ($) {
  function search() {
    const config = window.emSearchConfig;

    if (typeof config === "undefined") {
      throw new Error("Could not find the search configuration data.");
    }

    // const siteSearchEl = document.querySelector(".js-site-search");

    // if (siteSearchEl === null) {
    //   return;
    // }

    const modalEl = document.querySelector(".js-search-modal");
    const inputEl = document.querySelector(".js-search-input");
    const resultsEl = document.querySelector(".js-search-results");
    const itemsEl = document.querySelector(".js-search-items");
    const formEl = document.querySelector(".js-search-form");
    const announcerEl = document.querySelector(".js-search-announcer");

    const openEls = document.querySelectorAll(".js-search-open");
    const closeEls = document.querySelectorAll(".js-search-close");

    const init = () => {
      const requiredEls = { modalEl, inputEl, formEl, announcerEl };
      Object.keys(requiredEls).forEach((key) => {
        if (requiredEls[key] === null) {
          throw new Error(`Missing required el: ${key}`);
        }
      });

      const dialog = setupDialog(modalEl);

      setupModalOpenEvents(dialog);
      setupModalCloseEvents(dialog);

      setupInputEvent();
      setupFormEvent();
    };

    const setupDialog = (targetModalEl) => {
      const dialog = new A11yDialog(targetModalEl);
      dialog.on("show", () => {
        document.body.classList.add("has-search-open");
        focusInput();
        Array.from(openEls).forEach((el) => {
          el.setAttribute("aria-expanded", "true");
        });
      });
      dialog.on("hide", () => {
        document.body.classList.remove("has-search-open");
        Array.from(openEls).forEach((el) => {
          el.setAttribute("aria-expanded", "false");
          if (el.classList.contains("is-trigger")) {
            el.classList.remove("is-trigger");
            el.focus();
          }
        });
      });
      return dialog;
    };

    const setupModalOpenEvents = (dialog) => {
      Array.from(openEls).forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          el.classList.add("is-trigger");
          dialog.show();
        });
      });
    };

    const setupModalCloseEvents = (dialog) => {
      Array.from(closeEls).forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          dialog.hide();
        });
      });
    };

    const setupInputEvent = () => {
      inputEl.addEventListener("keyup", (e) => {
        e.preventDefault();
        debounceInput(makeSearch, inputEl.value);
      });
    };

    const setupFormEvent = () => {
      formEl.addEventListener("submit", (e) => {
        e.preventDefault();
        makeSearch(inputEl.value);
      });
    };

    const makeSearch = (str) => {
      if (str.length < config.minLength || str === window.currentSearch) {
        return false;
      }

      if (resultsEl === null || itemsEl === null) {
        throw new Error("Could not find required search elements.");
      }

      updateAnnouncer(config.text.loading);
      resetResults();

      // Get search results from the WordPress REST API
      const url = `${config.ajax_url}?action=${
        config.action
      }&s=${encodeURIComponent(str)}&lang=fi`;
      const requestOptions = {
        method: "GET",
      };

      // if (typeof ga !== "undefined") {
      //   // virtual pageview
      //   ga("send", {
      //     hitType: "pageview",
      //     location:
      //       "https://www.isannointiliitto.fi/?s=" +
      //       encodeURI(str) +
      //       "&s_type=quicksearch",
      //   });
      // }

      window
        .fetch(`${url}`, requestOptions)
        .then(parseFetchResponse)
        .then((data) => {
          window.currentSearch = str;
          populateResults(data);

          // Pinging analytics with searchterm, but only if user typing has stopped
          if (inputEl.value === str) {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            'event': 'search',
            'searchTerm': str,
            'searchLocation': 'header',
            });

            if (data.length) {
              const resultLinks = document.querySelectorAll(
                ".search-result__link"
              );

              resultLinks.forEach((link, index) => {
                link.addEventListener("click", () => {
                  // trackSearchResultClicks({
                  //   query: str,
                  //   results: data,
                  //   clickedUrl: link.getAttribute("href"),
                  //   clickedIndex: index,
                  // });
                });
              });
            }
          }

          updateAnnouncer(config.text.resultsDescription);
        })
        .catch((error) => {
          throw new Error(error);
        });
    };

    const resetResults = () => {
      resultsEl.classList.add("is-loading");
      itemsEl.innerHTML = "";
    };

    const populateResults = (data) => {
      resultsEl.classList.remove("is-loading");

      if (!data.length) {
        itemsEl.innerHTML = `<h4 class="site-search-results__error" aria-live="assertive" role="alert">${config.text.noResults}</h4>`;

        return false;
      }

      const posts = data.map((post, index) => {
        return buildPost(post, index);
      });

      itemsEl.innerHTML = posts.join("");
    };

    const buildPost = (post) => {
      return `
      <article class="site-search-results__item">
        <div class="search-result search-result--${post.type}">
          <a href="${post.link}" class="search-result__link wrapper-link">
            <h3 class="search-result__title">${post.title}</h3>
          </a>
        </div>
      </article>
    `;
    };

    const focusInput = () => {
      if (inputEl === null) {
        return false;
      }

      // Give CSS transition time to finish before setting focus
      setTimeout(() => {
        inputEl.focus();
      }, 500);
    };

    const debounceInput = (callback, args) => {
      clearTimeout(window.emSearchInputTimeout);

      window.emSearchInputTimeout = setTimeout(() => {
        callback(args);
      }, 250);
    };

    const updateAnnouncer = (str) => {
      announcerEl.innerHTML = str;
    };

    // Initialize component
    init();
  }

  $(document).ready(function () {
    search();
  });

  // (() => {
  //   document.addEventListener("DOMContentLoaded", () => {
  //     search();
  //   });
  // })();
})(jQuery);
